import React, { useEffect, useRef } from 'react';
import styles from './BasicTitle.module.scss';
import { gsap, Power1 } from 'gsap';
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

const tweenVars = [
  {
    y: '50',
    duration: 0.5,
    opacity: 0,
    ease: Power1.easeOut,
  },
];

interface Props {
  sectionTitle: {
    title: string;
    sub_title: string;
  };
  adjust?: string;
  tagType?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
}

const TitleFlex: React.FC<Props> = ({ sectionTitle, adjust = '', tagType = 'h3' }) => {
  const timeline = gsap.timeline();
  const title = useRef<HTMLElement>(null);

  useEffect(() => {
    if (title.current) {
      const children = title.current.querySelectorAll('span');

      // 初期状態を設定
      gsap.set(children, { opacity: 0 });

      const timeline = gsap.timeline();
      timeline.fromTo(
        children,
        { opacity: 0, y: 50 },
        { opacity: 1, y: 0, duration: 0.5, ease: Power1.easeOut, stagger: 0.3 }
      );

      ScrollTrigger.create({
        animation: timeline,
        trigger: title.current,
        start: 'top 90%',
        toggleActions: 'play none none play',
      });
    }
  }, []);

  const titleClassName = adjust ? `${styles.title} ${styles[adjust]}` : styles.title;

  return React.createElement(
    tagType,
    { className: titleClassName, ref: title },
    <>
      <span className={styles.title_en}>{sectionTitle.title}</span>
      <span className={styles.title_ja}>{sectionTitle.sub_title}</span>
    </>
  );
};

export default TitleFlex;
